interface AuditEntry<T = any> {
  who: string;
  role: string;
  action: string;
  timestamp: string;
  before?: T;
  after?: T;
}

export function logAudit(action: string, role: string, before?: any, after?: any, who: string = 'current-user') {
  const entry: AuditEntry = {
    who,
    role,
    action,
    timestamp: new Date().toISOString(),
    before,
    after,
  };
  try {
    const key = 'audit.log';
    const existing = localStorage.getItem(key);
    const arr = existing ? JSON.parse(existing) : [];
    arr.push(entry);
    localStorage.setItem(key, JSON.stringify(arr));
  } catch (e) {
    // Fallback to console
    console.warn('Audit storage failed, printing to console only');
  }
  // Always send to console for dev visibility
  // In production, connect to backend logging endpoint
  console.info('[AUDIT]', entry);
}
